/* Slider */ const SLICK_ARROW_COLOR = "white";
const SLICK_DOT_COLOR = "black";
const SLICK_DOT_SIZE = "0.338rem";
const SLICK_OPACITY_DEFAULT = "0.75";
const SLICK_OPACITY_ON_HOVER = "1";
const SLICK_OPACITY_NOT_ACTIVE = "0.25";
export const slickThemeStyle = `
    .slick-list {
      .slick-loading & {
        background: #fff url("./ajax-loader.gif") center center no-repeat;
      }
    }

    .slick-prev,
    .slick-next {
      position: absolute;
      display: block;
      height: 20px;
      width: 20px;
      line-height: 0px;
      font-size: 0rem;
      cursor: pointer;
      background: transparent;
      color: transparent;
      top: 50%;
      -webkit-transform: translate(0, -50%);
      -ms-transform: translate(0, -50%);
      transform: translate(0, -50%);
      padding: 0;
      border: none;
      outline: none;
      &:hover,
      &:focus {
        &:before {
          opacity: ${SLICK_OPACITY_ON_HOVER};
        }
      }
      &:focus {
        outline: 1px solid silver;
        outline-offset: 5px;
      }
      &.slick-disabled:before {
        opacity: ${SLICK_OPACITY_NOT_ACTIVE};
      }
      &:before {
        font-size: 1.125rem;
        line-height: 1;
        color: ${SLICK_ARROW_COLOR};
        opacity: ${SLICK_OPACITY_DEFAULT};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
    }

    .slick-prev {
      left: -25px;
      [dir="rtl"] & {
        left: auto;
        right: -25px;
      }
    }

    .slick-next {
      right: -25px;
      [dir="rtl"] & {
        left: -25px;
        right: auto;
      }
    }

    .slick-dotted.slick-slider {
      margin-bottom: 30px;
    }

    .slick-dots {
      position: absolute;
      bottom: -25px;
      list-style: none;
      display: block;
      text-align: center;
      padding: 0;
      margin: 0;
      width: 100%;
      li {
        position: relative;
        display: inline-block;
        height: 20px;
        width: 20px;
        margin: 0 5px;
        padding: 0;
        cursor: pointer;
        button {
          border: 0;
          background: transparent;
          display: block;
          height: 20px;
          width: 20px;
          outline: none;
          line-height: 0px;
          font-size: 0rem;
          color: transparent;
          padding: 5px;
          cursor: pointer;
          &:hover,
          &:focus {
            outline: none;
            &:before {
              opacity: ${SLICK_OPACITY_ON_HOVER};
            }
          }
          &:focus{
            outline: 1px solid silver;
            outline-offset: 7px;
          }
          &:before {
            position: absolute;
            top: 0;
            left: 0;
            width: 20px;
            height: 20px;
            font-size: ${SLICK_DOT_SIZE};
            line-height: 20px;
            text-align: center;
            color: ${SLICK_DOT_COLOR};
            opacity: ${SLICK_OPACITY_NOT_ACTIVE};
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }
        }
        &.slick-active button:before {
          color: ${SLICK_DOT_COLOR}-active;
          opacity: ${SLICK_OPACITY_DEFAULT};
        }
      }
    }

    .slick-dots {
      bottom: -50px;    
      li {
        margin: 0px 7px;

        button {
          display: inline-block;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          border: none;
          opacity: 1;

          background-color: rgba(0,0,0,0.25);
          
          &::before {
            display: none;
          }
        }
        &.slick-active {
          button {
            background-color: #595AD4;
          }
        }
        &:not(.slick-active):hover {
          button {
            background-color: black;
          }
        }
      }
    }
`;
